import React from 'react';

import clsx from 'clsx';
import { pipe } from 'rambdax';

import { useGetAllAsset } from '@ping/api';
import { DateTime } from '@ping/utils';

import style from './style.module.scss';

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  name: string;
  /** Optional icon URL from asset - used as-is when present */
  iconUrl?: string | null;
  width?: number;
  className?: string;
  onError?: () => void;
}

export const CoinIcon = ({ name, iconUrl: iconUrlProp, width, className = '', onError, ...rest }: IProps) => {
  const [state, setState] = React.useState<{ status: 'idle' | 'placeholder' | 'fallback' }>({ status: 'idle' });

  const { data: assetsData } = useGetAllAsset({
    query: {
      staleTime: DateTime.days(1),
      select: response => {
        const assets = response?.data ?? [];
        return new Map(assets.map(a => [a.id?.toUpperCase() ?? '', a.icon_url] as const));
      },
    },
  });

  const iconUrlFromAssets = assetsData?.get(name.toUpperCase());
  const iconUrl = iconUrlProp ?? iconUrlFromAssets;

  const primarySrc = iconUrl ?? '/img/icon/placeholder.svg';

  return (
    <>
      {state.status === 'idle' && (
        <img
          src={primarySrc}
          onError={() => setState({ status: 'placeholder' })}
          className={clsx(style['coin-icon'], className)}
          alt={name}
          width={width}
          {...rest}
        />
      )}
      {state.status === 'placeholder' && (
        <img
          src={'/img/icon/placeholder.svg'}
          onError={pipe(() => setState({ status: 'fallback' }), onError)}
          className={clsx(style['coin-icon'], className)}
          alt={`${name}'s placeholder`}
          width={width}
          {...rest}
        />
      )}
      {state.status === 'fallback' && <span className={clsx(style['text-substitute'], className)}>{name}</span>}
    </>
  );
};
